/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBluetooth = createReactComponent("bluetooth", "IconBluetooth", [
  ["path", { d: "M7 8l10 8l-5 4l0 -16l5 4l-10 8", key: "svg-0" }]
]);

export { IconBluetooth as default };
//# sourceMappingURL=IconBluetooth.js.map
